// extracted by mini-css-extract-plugin
export default {"filterCollapse":"Table_filterCollapse__PNClD"};